import { render, staticRenderFns } from "./AttendancesDesktop.vue?vue&type=template&id=5e534df8&"
import script from "./AttendancesDesktop.vue?vue&type=script&lang=js&"
export * from "./AttendancesDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports